import { render, staticRenderFns } from "./InternalPersonManagement.vue?vue&type=template&id=cdfa4e60&scoped=true"
import script from "./InternalPersonManagement.vue?vue&type=script&lang=js"
export * from "./InternalPersonManagement.vue?vue&type=script&lang=js"
import style0 from "./InternalPersonManagement.vue?vue&type=style&index=0&id=cdfa4e60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfa4e60",
  null
  
)

export default component.exports